module.exports = __webpack_public_path__ + "img/26_220.fef9c73a.png";